export default __webpack_public_path__ + "static/media/aurumlogin.490edcf6.png";